/**
 * Size-selection gate + popup for the product page.
 * No size is pre-selected on load; clicking Add to Cart with no size opens a popup
 * (desktop modal / mobile sheet). Picking a size drives the real variant-picker, then
 * re-triggers Add to Cart so the theme's normal add + animation runs. If a size is already
 * chosen, Add to Cart adds directly. See the accompanying snippet size-selector-popup.liquid.
 */
(function () {
  var PDP_FORM_SELECTOR = 'form.product_page_atc_cstm_desktop, form.product_page_atc_cstm_mobile';

  var activeButton = null;
  var activeForm = null;

  function getMainPicker() {
    return document.querySelector('variant-picker[data-template-product-match="true"]');
  }

  /**
   * On the product page we want no size chosen on load, so the shopper must pick one.
   * Horizon server-renders the first available option as checked; clear it (main PDP picker
   * only). The hidden form variant id stays populated but is gated behind size selection.
   */
  function clearPreselection() {
    // Clear the server-rendered default selection so no size is pre-selected on load.
    // Setting only .checked = false leaves the `checked` ATTRIBUTE and defaultChecked in place,
    // which desyncs the attribute from the property. That stale default can be resurrected by a
    // form reset or a back/forward (bfcache) restore, and it fights the variant-picker's own
    // state — surfacing as the wrong size appearing selected. Clear all three so the DOM is
    // fully consistent: no size selected, no lingering default. Match by property OR attribute.
    var pickers = document.querySelectorAll('variant-picker[data-template-product-match="true"]');
    for (var p = 0; p < pickers.length; p++) {
      var radios = pickers[p].querySelectorAll(
        'fieldset.variant-option input[type="radio"]:checked, fieldset.variant-option input[type="radio"][checked]'
      );
      for (var i = 0; i < radios.length; i++) {
        radios[i].checked = false;
        radios[i].defaultChecked = false;
        radios[i].removeAttribute('checked');
      }
    }
  }

  function getPopup() {
    return document.querySelector('size-selector-popup');
  }

  /**
   * True when every option group in the main picker has a checked value (or there is no
   * button-style picker at all, e.g. single-variant / dropdown products — those add directly).
   */
  function isFullySelected(picker) {
    if (!picker) return true;
    var fieldsets = picker.querySelectorAll('fieldset.variant-option');
    if (!fieldsets.length) return true;
    for (var i = 0; i < fieldsets.length; i++) {
      if (!fieldsets[i].querySelector('input[type="radio"]:checked')) return false;
    }
    return true;
  }

  function pickerInputFor(picker, optionValueId) {
    if (!picker || !optionValueId) return null;
    var esc = window.CSS && CSS.escape ? CSS.escape(optionValueId) : optionValueId;
    return picker.querySelector('input[data-option-value-id="' + esc + '"]');
  }

  function syncPopupSelection() {
    var popup = getPopup();
    var picker = getMainPicker();
    if (!popup || !picker) return;
    var values = popup.querySelectorAll('.cstm-size-popup__value');
    for (var i = 0; i < values.length; i++) {
      var input = pickerInputFor(picker, values[i].getAttribute('data-option-value-id'));
      var selected = !!(input && input.checked);
      values[i].classList.toggle('is-selected', selected);
    }
  }

  function openPopup(button) {
    var popup = getPopup();
    if (!popup) return false;
    activeButton = button;
    activeForm = button.closest('form');
    syncPopupSelection();
    popup.hidden = false;
    document.documentElement.classList.add('cstm-size-popup-open');
    return true;
  }

  function closePopup() {
    var popup = getPopup();
    if (popup) popup.hidden = true;
    document.documentElement.classList.remove('cstm-size-popup-open');
  }

  function syncPreorderInput(form, isPreorder) {
    if (!form) return;
    var existing = form.querySelector('.pre_order_prop_atc');
    if (isPreorder && !existing) {
      form.insertAdjacentHTML(
        'afterbegin',
        '<input type="hidden" name="properties[Type]" value="Preorder" class="pre_order_prop_atc">'
      );
    } else if (!isPreorder && existing) {
      existing.remove();
    }
  }

  var VARIANT_RESOLVE_TIMEOUT = 2000;
  var VARIANT_RESOLVE_INTERVAL = 50;

  function showPopupError() {
    var popup = getPopup();
    if (!popup) return;
    var err = popup.querySelector('.cstm-size-popup__error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'cstm-size-popup__error';
      err.setAttribute('role', 'alert');
      err.style.cssText = 'margin:12px 0 0;color:#c0392b;font-size:13px;font-weight:600;';
      var container = popup.querySelector('.cstm-size-popup__body') || popup.querySelector('.cstm-size-popup__panel') || popup;
      container.appendChild(err);
    }
    err.textContent = "Couldn't confirm your size — please tap it again.";
    err.hidden = false;
  }

  function clearPopupError() {
    var popup = getPopup();
    if (!popup) return;
    var err = popup.querySelector('.cstm-size-popup__error');
    if (err) err.hidden = true;
  }

  function addSelectedToCart(valueButton) {
    var form = activeForm || document.querySelector(PDP_FORM_SELECTOR);
    var button = activeButton || (form && form.querySelector('.cstm_add_to_cart'));
    if (!form || !button) {
      closePopup();
      return;
    }

    var idInput = form.querySelector('input[name="id"]');
    var variantId = valueButton && valueButton.getAttribute('data-variant-id');
    var isPreorder = valueButton && valueButton.getAttribute('data-eligible-preorder') === 'true';

    // Set the hidden id (when known), sync preorder, close, and reuse the theme's normal add
    // pipeline (animation + fly-to-cart + add). The variantSelected handler disables the
    // button on selection, so re-enable it before the programmatic click.
    var addWith = function (resolvedId) {
      if (idInput && resolvedId) idInput.value = resolvedId;
      syncPreorderInput(form, isPreorder);
      clearPopupError();
      closePopup();
      button.disabled = false;
      button.click();
    };

    // Fast path: single-option products carry a concrete variant id, so there is no picker
    // race — set it directly and add.
    if (variantId) {
      addWith(variantId);
      return;
    }

    // Multi-option products: the correct variant id only exists once the theme's variant
    // picker finishes resolving the selected option combination. Wait for that to actually
    // happen (the picker re-enables the button and writes the resolved id) instead of
    // guessing a fixed delay. Hard-cap the wait so the UI can never hang.
    if (!idInput) {
      addWith(null);
      return;
    }

    var startId = idInput.value;
    var wasDisabled = button.disabled === true;
    var waited = 0;
    var poll = setInterval(function () {
      waited += VARIANT_RESOLVE_INTERVAL;
      var idNow = idInput.value;
      var resolved = button.disabled === false && idNow && (idNow !== startId || wasDisabled);
      if (resolved) {
        clearInterval(poll);
        addWith(null); // trust the id the picker just wrote
      } else if (waited >= VARIANT_RESOLVE_TIMEOUT) {
        clearInterval(poll);
        // Resolution genuinely failed — do NOT add a stale/wrong variant. Prompt a retry.
        showPopupError();
      }
    }, VARIANT_RESOLVE_INTERVAL);
  }

  /**
   * Shared predicate used by product-form.js handleClick to decide whether a click should be
   * gated (open the popup, no add/animation). True only for a PDP main/sticky ATC button on a
   * product that has a size popup and no size selected yet.
   * @param {EventTarget|null} eventTarget
   */
  window.cstmSizeGateActive = function (eventTarget) {
    var el = eventTarget && eventTarget.closest ? eventTarget : null;
    var button = el && el.closest('.cstm_add_to_cart');
    if (!button) return false;
    if (!button.closest(PDP_FORM_SELECTOR)) return false;
    if (!getPopup()) return false;
    return !isFullySelected(getMainPicker());
  };

  // --- Gate: capture ATC clicks with no size chosen, before any theme handler runs. ---
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var button = target.closest('.cstm_add_to_cart');
      if (!button) return;
      var form = button.closest(PDP_FORM_SELECTOR);
      if (!form) return; // not a PDP main/sticky Add to Cart button
      if (!getPopup()) return; // no size popup on this product -> normal behaviour

      if (isFullySelected(getMainPicker())) return; // size chosen -> let it add

      event.preventDefault();
      event.stopImmediatePropagation();
      openPopup(button);
    },
    true
  );

  // --- Popup interactions ---
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-size-popup-close]')) {
      closePopup();
      return;
    }

    var value = target.closest('.cstm-size-popup__value');
    if (!value) return;
    if (value.getAttribute('aria-disabled') === 'true') return;

    var picker = getMainPicker();
    if (!picker) return;

    clearPopupError();

    var input = pickerInputFor(picker, value.getAttribute('data-option-value-id'));
    if (input) {
      // Always (re-)dispatch change: drives the theme's variant resolution, and lets a
      // shopper retry after an error by tapping the same size again.
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    syncPopupSelection();

    if (isFullySelected(picker)) {
      addSelectedToCart(value);
    }
  });

  // Keep the popup highlight in sync when the shopper selects inline on desktop.
  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('variant-picker')) {
      syncPopupSelection();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePopup();
  });

  // Enforce "no size pre-selected" on load, and re-clear if the picker is re-rendered
  // (e.g. combined-listing morph) before the shopper has interacted.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearPreselection);
  } else {
    clearPreselection();
  }
  // DOMContentLoaded does not fire on a back/forward (bfcache) restore, which would otherwise
  // bring back the server default as selected. Re-clear on persisted pageshow.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) clearPreselection();
  });
})();
